module.exports = __webpack_public_path__ + "static/media/icon_note.eb58979c.svg";